import React from 'react';
import BasePage from '@/components/BasePage';
import BaseLayout from '@/components/layouts/BaseLayout';
import Travels from '@/pages/travels';
import routeChecker from '@/Hooks/routeChecker';
import Vaccines from '@/pages/vaccines';
import { Container } from 'reactstrap';

const Error = ({ error }) => {
	return (
		//React.Fragment is used instead of <div> or <> to hide it from source
		<React.Fragment>
			<BaseLayout className="cover" title={error} description={error} keywords={error}>
				{/* Base Page - Shared component with Container */}
				<BasePage id="error-page" className="pt-5 pb-5">
					<Container>
						<h1 className="page_text font-weight-bold text-center">{error}</h1>
						{routeChecker('/vaccines/[id]') ? <Vaccines /> : <Travels />}
					</Container>
				</BasePage>
			</BaseLayout>
		</React.Fragment>
	);
};
export default Error;
